"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = void 0;
// I just need a contract change to force a release, i'll revert this commit afterwards
var NotificationType;
(function (NotificationType) {
    NotificationType["WALLET_RUNNING_DRY"] = "wallet-running-dry";
    NotificationType["ADMIN_WALLET_LOAD"] = "admin-wallet-load";
    NotificationType["ADMIN_LIMIT_REACHED"] = "admin-limit-reached";
    NotificationType["MISSING_DETAILS_RECEIPTS"] = "missing-details-expenses";
    NotificationType["MISSING_DETAILS_EOM"] = "missing-details-end-of-month";
    NotificationType["FORWARDED_RECEIPT_SUCCESS"] = "forwarded-receipt-success";
    NotificationType["SUSPICIOUS_TRANSACTION"] = "suspicious-transaction";
    NotificationType["BILL_PAYMENT_FAILURE"] = "bill-payment-failure";
    NotificationType["NEW_BILLS"] = "new-bills";
    NotificationType["BILL_UPLOAD_FAILURE_NO_OWNER"] = "bill-upload-failure-no-owner";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
//# sourceMappingURL=user-notifications-settings.js.map